import exchangeRate from '@/api/administration/exchange-rate'
import apiCurreny from '@/api/administration/exchange-rate-currency'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  currencies: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_CURRENCIES(state, currencies) {
    state.currencies = currencies
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return exchangeRate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchCurrency({ commit }) {
    return apiCurreny.get().then(response => {
      commit('RECEIVE_CURRENCIES', response.data)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return exchangeRate.store(data)
  },

  update(context, data) {
    return exchangeRate.update(data)
  },

  delete(context, data) {
    return exchangeRate.destroy(data)
  }
}
